import { FC, useEffect } from 'react';
import { Tab, Tabs, TabsProps, Tooltip } from '@mui/material';
import { HelpOutlineOutlined as HelpOutlineOutlinedIcon } from '@mui/icons-material';
import { TabsContainer, TabsContainerProps } from '../../../../components/Tabs';
import Row from '../../../../components/Row';

import { HatCriteria } from '../../../../types/Criteria/HatCriteria';
import { useHatDashboardPageContext } from '../../../../hooks/Pages/HatDashboardPage';

const HAT_MEDIA_TABS = {
    ALL: 0,
    DISPLAY: 1,
    ONLINE_VIDEO: 2,
    STREAMING_TV: 3,
    AUDIO: 4,
    VIDEO: 5,
};

type HatMediaTabsProps = {
    slotProps?: {
        tabsContainer?: TabsContainerProps;
    };
} & TabsProps;

const HatMediaTabs: FC<HatMediaTabsProps> = ({ slotProps = {}, ...tabsProps }): React.JSX.Element => {
    const { mediaTabs, setHatCriteria } = useHatDashboardPageContext();

    useEffect(() => {
        let mediaType: string = '';

        switch (mediaTabs.activeTab) {
            case HAT_MEDIA_TABS.ALL:
                mediaType = '';
                break;
            case HAT_MEDIA_TABS.DISPLAY:
                mediaType = 'Display';
                break;
            case HAT_MEDIA_TABS.AUDIO:
                mediaType = 'Audio';
                break;
            case HAT_MEDIA_TABS.ONLINE_VIDEO:
                mediaType = 'Online Video';
                break;
            case HAT_MEDIA_TABS.STREAMING_TV:
                mediaType = 'Streaming TV';
                break;
            // Note: Legacy media type
            case HAT_MEDIA_TABS.VIDEO:
                mediaType = 'Video';
                break;
        }

        setHatCriteria((prev: HatCriteria) => ({
            ...prev,
            mediaType: mediaType,
        }));
    }, [mediaTabs.activeTab, setHatCriteria]);

    return (
        <TabsContainer sx={{ mt: 2 }} {...slotProps?.tabsContainer}>
            <Tabs {...tabsProps}>
                <Tab value={HAT_MEDIA_TABS.ALL} label="All Media" />
                <Tab value={HAT_MEDIA_TABS.DISPLAY} label="Display" />
                <Tab value={HAT_MEDIA_TABS.ONLINE_VIDEO} label="Online Video" />
                <Tab value={HAT_MEDIA_TABS.STREAMING_TV} label="Streaming TV" />
                <Tab value={HAT_MEDIA_TABS.AUDIO} label="Audio" />
                <Tab
                    value={HAT_MEDIA_TABS.VIDEO}
                    label={
                        <Row gap={1} alignItems="center" width="auto">
                            Video
                            <Tooltip title="Video is a legacy media type that may contain a combination of one or many Online Video and or Streaming TV campaigns.">
                                <HelpOutlineOutlinedIcon color="action" sx={{ fontSize: 16 }} />
                            </Tooltip>
                        </Row>
                    }
                />
            </Tabs>
        </TabsContainer>
    );
};

export type { HatMediaTabsProps };
export { HAT_MEDIA_TABS };
export default HatMediaTabs;
